module.exports = __webpack_public_path__ + "img/SideImage.c23126f8.png";